export const enum THUMBNAIL_SIZE {
  SQUARE_EXTRA_SMALL = 'sq-xs',
  SQUARE_SMALL = 'sq-sm',
  SMALL = 'sm',
  MEDIUM = 'md',
  WIDE_MEDIUM = 'wide-md',
  GYM_EVENT = 'gym-event',
}

export const THUMBNAIL_SIZES = [
  THUMBNAIL_SIZE.SQUARE_EXTRA_SMALL,
  THUMBNAIL_SIZE.SQUARE_SMALL,
  THUMBNAIL_SIZE.SMALL,
  THUMBNAIL_SIZE.MEDIUM,
  THUMBNAIL_SIZE.WIDE_MEDIUM,
  THUMBNAIL_SIZE.GYM_EVENT,
] as const;
